import React from 'react';

import AfterDownload from '../features/AfterDownloadPage/AfterDownloadPage';

function AfterDownloadPage() {
    return <AfterDownload />;
}

export default AfterDownloadPage;
